var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.419 13.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-laptop",
    "data-name": "Icon awesome-laptop",
    d: "M16.984,11.323h-6.6a.858.858,0,0,1-.891.871H7.839a.924.924,0,0,1-.892-.871H.435A.437.437,0,0,0,0,11.758v.435a1.747,1.747,0,0,0,1.742,1.742H15.677a1.747,1.747,0,0,0,1.742-1.742v-.435A.437.437,0,0,0,16.984,11.323ZM15.677,1.306A1.31,1.31,0,0,0,14.371,0H3.048A1.31,1.31,0,0,0,1.742,1.306v9.145H15.677Zm-1.742,7.4H3.484V1.742H13.936Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.64ebac7be7bde9af965d3cb22574b466.svg";
export { ForwardRef as ReactComponent };